module.exports = __webpack_public_path__ + "static/amit-0b331cceadfa687a08aab14c0da59f3d.jpg";